import { Link } from "react-router-dom"
import useGlobalContext from "../context/GlobalContext"

const Header = () => {
  const { changeCursor, setShowMenu } = useGlobalContext()

  return (
    <header>
      <div className="container flex space-between align-center">
        <div
          onMouseEnter={() => changeCursor("hovered")}
          onMouseLeave={() => changeCursor("")}
          className="flex align-baseline gap-sm h-100"
        >
          <Link
            to="/"
            className="select-none uppercase mix-blend-difference logo f-light"
          >
            PixieAutumn
          </Link>
          <span className="select-none uppercase mix-blend-difference color-light par-md no-mobile">
            Directorofphotography
          </span>
        </div>
        <button
          onClick={() => setShowMenu(true)}
          onMouseEnter={() => changeCursor("btn-hover")}
          onMouseLeave={() => changeCursor("")}
          className="btn menu-btn uppercase pointer mix-blend-difference"
        >
          Menu
        </button>
      </div>
    </header>
  )
}

export default Header
